const session_job_types = [
    'daily_stats_build',
    'анализ интенсивности тематик',
    'семантическая ролевая маркировка',
    'активность',
    'анализ аномальности дискуссий',
    'расчет текстовых маркеров',
    'group',
    'анализ временных рядов'
];


const session_job_types_by_routes = {
    '/': 'анализ временных рядов',
    '/trager-dynamics': 'анализ временных рядов',
    '/dynamics-context': 'анализ временных рядов',
    '/season-index': 'анализ временных рядов',
    '/time-series': 'анализ временных рядов',
    '/pol': 'group',
    '/diss': 'активность',
    '/diss/community-activity': 'активность',
    '/diss/anomaly': 'анализ аномальности дискуссий',
    '/diss/markers': 'расчет текстовых маркеров',
    // '/diss/disscussions': 'details',
    '/topics-analysis': 'анализ интенсивности тематик',
    '/emotive-analysis': 'семантическая ролевая маркировка',
};

const dynamic_session_job_types = [
  'анализ интенсивности тематик',
  'активность',
  'анализ аномальности дискуссий',
  'group',
  'анализ временных рядов'
];

export const isDynamicSessionJobType = (job_type) => {
    return dynamic_session_job_types.includes(job_type);
  }

export { session_job_types, dynamic_session_job_types, session_job_types_by_routes };
